import firebase from 'firebase/app'
import { notification } from 'antd'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import API from './config/api'

// const firebaseConfig = {
//   apiKey: 'AIzaSyAE5G0RI2LwzwTBizhJbnRKIKbiXQIA1dY',
//   authDomain: 'cleanui-72a42.firebaseapp.com',
//   databaseURL: 'https://cleanui-72a42.firebaseio.com',
//   projectId: 'cleanui-72a42',
//   storageBucket: 'cleanui-72a42.appspot.com',
//   messagingSenderId: '583382839121',
// }

const firebaseConfig = {
  apiKey: 'AIzaSyDV0yXfF0xUjvpGb_YHH8kvHFkdJfZbWfA',
  authDomain: 'wiz365.firebaseapp.com',
  databaseURL: 'https://wiz365.firebaseio.com',
  projectId: 'wiz365',
  storageBucket: 'wiz365.appspot.com',
  messagingSenderId: '1018238749110',
  appId: '1:1018238749110:web:5878b535fede72061ed917',
  measurementId: 'G-E6WGXYZW02',
}

const firebaseApp = firebase.initializeApp(firebaseConfig)
const firebaseAuth = firebase.auth
export default firebaseApp

export async function login(email, password) {
  return firebaseAuth()
    .signInWithEmailAndPassword(email, password)
    .then(() => true)
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

export async function currentAccount() {
  let userLoaded = false
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser)
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        resolve(user)
      }, reject)
    })
  }
  return getCurrentUser(firebaseAuth())
}

export async function logout() {
  return firebaseAuth()
    .signOut()
    .then(() => true)
}

export async function getUsers(data) {
  const { size, page, search, sort, accessToken } = data
  // console.log("directory search")
  // console.log(data)
  // console.log(data.acccessToken)
  return API.get('getUsers', {
    params: {
      size,
      search,
      sort,
      page,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

export async function getRoles() {
  return API.get(`getAllRoles`, {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  })
}

export async function enableUser(data) {
  return API.get(`enableUser/${data.key}`, {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  })
}

export async function disableUser(data) {
  return API.get(`disableUser/${data.key}`, {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  })
}

export async function kickOutUser(data) {
  return API.get(`kickOutUser/${data.key}`, {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  })
}

export async function deleteMultiUsers(data) {
  return API.post(
    `deleteMultipleUsers`,
    { ids: data.keys },
    {
      // headers: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
    },
  )
}

export async function disableMultiUsers(data) {
  return API.post(
    `disableMultipleUsers`,
    { ids: data.keys },
    {
      // headers: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
    },
  )
}

export async function kickoutMulitpleUsers(data) {
  return API.post(
    `kickoutMultipleUser`,
    { ids: data.keys },
    {
      // headers: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
    },
  )
}

export async function assignORunassignMulitpleUsers(data) {
  const { type, keys, roleName } = data
  return API.post(
    type !== 'assign' ? `removeMultipleUserRole` : `updateMultipleUserRole`,
    { ids: keys, roleName },
    {
      // headers: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
    },
  )
}

// export async function uploadCSV(data) {
//   return API.post(
//     'registerUsersList',
//     { file: data.file },
//     {
//       headers: {
//         Authorization: `Bearer ${data.token}`,
//       },
//     },
//   )
// }

export async function uploadCSV(data) {
  const formData = new FormData()
  formData.append('file', data.file)
  return API.post('registerUsersList', formData, data.config, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${data.token}`,
    },
  })
}

export async function editUser(data) {
  return API.post(
    'editUser',
    { ...data },
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    },
  )
}
